import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTag from "@/enum/OrderTag";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTagWrap from "../OrderTagWrap";
import { Tooltip } from "antd";

/**
 * 鲸灵平台标签组件
 * 包含所有鲸灵相关的标签逻辑
 */
export default function useJlTagIcons(order: OrderDTO, orderTagSet: Set<OrderTag>, shop: ShopDTO) {
    const icons = [];

    if (orderTagSet.has(OrderTag.JL_OUT_ORDER_CHANNELSHOP)) {
        icons.push(
            <Tooltip
                title="微信小店加密分销：下游订单为微信小店平台订单，请使用微信小店电子面单打印"
                key={OrderTag.JL_OUT_ORDER_CHANNELSHOP}
            >
                <OrderTagWrap
                    className="order-icon icon-important"
                    style={{ whiteSpace: "nowrap" }}
                    orderTag={OrderTag.JL_OUT_ORDER_CHANNELSHOP}
                />
            </Tooltip>,
        );
    }

    return icons;
}
